import { render } from "./indextendoctor.vue?vue&type=template&id=3175e38a"
import script from "./indextendoctor.vue?vue&type=script&lang=js"
export * from "./indextendoctor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__